import React, { useContext } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { LargeMonitorContext } from '../context';
import { toSnakeCase } from '../helpers/common';

const IconTip = (props) => {
  const largeMonitorContext = useContext(LargeMonitorContext);
  const { module } = props;
  const { anchorTagLinkText, image, tip } = module;

  return (
    <section
      className="icon-tip"
      id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
    >
      <Container>
        <Grid>
          <Grid.Row className="icon-tip__row">
            <Grid.Column
              mobile={12}
              tablet={12}
              computer={largeMonitorContext ? 10 : 12}
              largeScreen={10}
              className="icon-tip__column"
            >
              <div className="icon-tip__content">
                <img
                  className="icon-tip__image"
                  src={image.sourceUrl}
                  alt={image.altText !== null ? image.altText : ''}
                />
                <div
                  className="icon-tip__text"
                  dangerouslySetInnerHTML={{ __html: tip }}
                ></div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default IconTip;
